<template>
  <el-submenu
    v-if="menu.children && menu.children.length >= 1 && menu.visible"
    :index="menu.url + ''"
    :popper-append-to-body="false"
  >
    <template slot="title">
      <i :class="menu.icon" v-if="showIcon"></i>
      <span slot="title">{{ menu.displayName }}</span>
    </template>
    <menu-tree
      v-for="item in menu.children"
      :key="item.url"
      :menu="item"
    ></menu-tree>
  </el-submenu>
  <el-menu-item v-else :index="menu.url" @click="handleRoute(menu)">
    <i :class="menu.icon"></i>
    <span slot="title">{{ menu.displayName }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: "menu-tree",
  props: {
    menu: {
      type: Object,
      required: true,
    },
    showIcon: {
      default: false,
    },
  },
  methods: {
    handleRoute(menu) {
      // 通过菜单URL跳转至指定路由
      if (menu.name == "home") {
        // 如果当前是进入后的且为进入到学校时 调整至学校首页
        if (
          this.$store.getters.isEnterOrg &&
          this.$store.getters.currentRoleGroup == 3
        ) {
          this.$router.push({ path: "/schoolHome" });
        } else {
          this.$router.push(menu.url);
        }
      } else {
        this.$router.push(menu.url);
      }
    },
    // getPath(path) {
    //     if (typeof path === 'undefined') {
    //         return
    //     }
    //     const index = path.indexOf('.')
    //     return path.substring(0, index)
    // }
  },
};
</script>

<style lang="css" scoped>
/*/deep/.menuTree .menu-text {*/
/*margin-left: 8px;*/
/*margin-right: 24px;*/
/*}*/

/*/deep/.menuTree .el-submenu__title:hover {*/
/*background-color: transparent;*/
/*color:white;*/
/*}*/
/*/deep/.menuTree .custom-element .el-menu--horizontal>.el-menu-item.is-active {*/
/*background-color: rgba(255, 255, 255, 0.2) !important;*/
/*border-bottom: none;*/
/*color: rgb(255, 255, 255);*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/MenuTree.vue